import React, { Component } from 'react';
import { withRouter } from 'react-router';
import Spinnable from './../../reusable/Wrappers/SpinnerWrapper/SpinnerWrapper.jsx';
import CreateAlertPage from './../AlertsCreate/CreateAlertPage.jsx';

import alertEditApi from './AlertsEdit.api.js';
import xhr from "../../utils/xhr";
import {
    EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK,
    EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK,
    EXPERIAN_DELINQUENCY_STRINGS,
    EXPERIAN_STABILITY_STRINGS,
} from '../../constants';

class EditAlertPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: null
        };

    }

    componentDidMount() {

        this.props.spinner.showSpinner();

        alertEditApi.getAlertData(this.props.routeParams.alertId)
            .then((response) => {

                let thirdPartySelection = 'all-third-parties-section';
                if (response.body.alertFilterMeta.categories.length > 0) {
                    thirdPartySelection = 'categories-section';
                }
                if (response.body.alertFilterMeta.thirdParties.length > 0) {
                    thirdPartySelection = 'specific-third-parties-section';
                }

                let alertsCreatePageDataStructure = {
                    active:             response.body.active,
                    alertId:            response.body.id,
                    name:               response.body.name,
                    thirdParty:         {
                        categoryNames:           {},
                        selectedCategories:      response.body.alertFilterMeta.categories,
                        selectedThirdPartiesIds: response.body.alertFilterMeta.thirdParties,
                        selectedThirdParties:    [],
                        thirdPartySelection:     thirdPartySelection,
                        urlParams:               {
                            categoryIdFilter: null,
                            direction:        'asc',
                            sortBy:           'companyTitleSort'
                        }
                    },
                    isNewsAlertsActive: response.body.newsActive,
                    isSwActive:         response.body.swActive,
                    isExperianActive:   response.body.experianActive,
                    experianRiskAngles: {
                        stabilityRisk:   response.body.experianMeta && response.body.experianMeta.stabilityRiskType ?
                                             EXPERIAN_STABILITY_STRINGS.indexOf(
                                                 response.body.experianMeta.stabilityRiskType) :
                                             EXPERIAN_DEFAULT_SLIDER_LEVEL_STABILITY_RISK,
                        delinquencyRisk: response.body.experianMeta && response.body.experianMeta.delinquencyRiskType ?
                                             EXPERIAN_DELINQUENCY_STRINGS.indexOf(
                                                 response.body.experianMeta.delinquencyRiskType) :
                                             EXPERIAN_DEFAULT_SLIDER_LEVEL_DELINQUENCY_RISK
                    },
                    riskAngles:         {
                        political:     response.body.alertFilterMeta.riskLevels.political,
                        economic:      response.body.alertFilterMeta.riskLevels.economic,
                        social:        response.body.alertFilterMeta.riskLevels.social,
                        technological: response.body.alertFilterMeta.riskLevels.technological,
                        legal:         response.body.alertFilterMeta.riskLevels.legal,
                        environmental: response.body.alertFilterMeta.riskLevels.environmental
                    },
                    emails:             response.body.recipientData.emails.join(),
                    frequency:          response.body.scheduleMeta.frequency,
                    sendAs:             response.body.recipientData.deliveryType,
                    format:             response.body.recipientData.attachType
                };

                this.setState({data: alertsCreatePageDataStructure});

                this.props.spinner.hideSpinner();

            }).catch((error) => {
            xhr.handleAllErrors(error);
            console.log("********************** Edit Alert Load Failed ********************");
        });
    }

    render() {
        return (
            <div className="edit-alert-page">
                {this.state.data ? <CreateAlertPage subHeaderMessage={'editAlert'} data={this.state.data} /> : null}
            </div>
        )
    }

}

export default withRouter(Spinnable(EditAlertPage));


// WEBPACK FOOTER //
// ./src/scripts/pages/AlertsEdit/AlertsEditPage.jsx